import React, {Component} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DomainsApi from '../../api/domains';
import {connect} from 'react-redux';
import {showError, showMessage, confirmAction} from '../../actions/uiActions';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import DomainSurveyItem from "./DomainSurveyItem";

import './DomainSurveyItem.css';

class DomainSurvey extends Component {
	constructor() {
		super();
		this.state = {
			busy: false,
			survey: [{
				id: Date.now().toString(),
				name: '',
				type: 'text',
			}]
		}
	}

	componentDidMount() {
		if (this.props.survey) {
			this.setState({survey:[...this.props.survey,...this.state.survey]});
		}
	}

	renderSurveyForm = () => {
		const {survey} = this.state;
		return (
			<div className="domain-survey-form">
				<ul className="domain-survey-container">
				{survey.map((item,index) => (
					<DomainSurveyItem
						onSave={this.addSurveyItem}
						canDelete={index!==(survey.length-1)}
						key={item.id}
						item={item}
						delete={this.deleteSurveyItem}
						onEdit={this.saveSurveyItem}
					/>
				))}
				</ul>
				
			</div>
		);
	};

	saveSurveyItem = (item) => {
		const survey = this.state.survey.map(i => i.id === item.id ? item : i);
		this.setState({survey})
	};

	deleteSurveyItem = item => {
		this.setState({survey: this.state.survey.filter(s => s !== item)})
	};

	addSurveyItem = (item) => {
		const newItem = {
			id: Date.now().toString(),
			name: '',
			type: 'text',
		};
		this.setState({survey: [...this.state.survey.slice(0,this.state.survey.length-1),item, newItem]})
	};

	delete = () => {
		this.props.confirmAction("You are going to delete the survey for this Company, therefore customers of this company will no longer be required to complete a survey. Do you want to proceed?",
			() => this.setState(
				{busy: true},
				() => DomainsApi.deleteSurvey(this.props.id)
					.then(
						success => {
							this.props.showMessage("The survey has been deleted.");
							this.props.onSurveyUpdated(this.props.id, []);
							this.props.onClose();
						},
						error => this.setState({busy: false}, this.props.showError))
					.catch(error => this.setState({busy: false}, this.props.showError))))
	};

	save = () => {
		//Validate the user input
		// console.log(this.state.survey);
		if(this.state.survey.length<=1) {
			this.props.showError("You must add at least one question to the survey.")
		} else {
			this.setState(
				{busy: true},
				() => DomainsApi.saveSurvey(this.props.id, this.state.survey.slice(0,this.state.survey.length-1))
					.then(
						success => {
							this.props.showMessage("The survey has been updated successfully!");
							this.props.onSurveyUpdated(this.props.id, this.state.survey);
							this.props.onClose();
						},
						error => this.setState({busy: false}, this.props.showError))
					.catch(error => this.setState({busy: false}, this.props.showError)));
		}

		
	};

	render() {
		return <Dialog fullWidth={true} maxWidth="xl"
		               aria-labelledby="alert-dialog-title"
		               aria-describedby="alert-dialog-description" open={true}
		>
			<DialogTitle id="alert-dialog-title">Create Domain Survey</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					Use the form below to create the survey that borrowers of this company will have to complete.
				</DialogContentText>
				{this.renderSurveyForm()}
				{this.state.busy && <LinearProgress/>}
			</DialogContent>
			{!this.state.busy && <DialogActions>

				<Button variant="outlined" onClick={this.save} color="primary" autoFocus>
					Update Survey
				</Button>
				<Button onClick={this.delete} color="primary">
					Delete Survey
				</Button>
				<Button onClick={this.props.onClose} color="primary">
					Cancel
				</Button>
			</DialogActions>}
		</Dialog>;
	}
}

DomainSurvey.propTypes = {
	survey: PropTypes.array,
	onClose: PropTypes.func,
	onSurveyUpdated: PropTypes.func,
	id: PropTypes.string
};


export default connect(null, {showError, showMessage, confirmAction})(DomainSurvey);
